import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "../../lib/utils"

const Slider = React.forwardRef(({ className, onValueChange, onValueCommit, ...props }, ref) => {
  // Handle local state for immediate feedback while dragging
  // This bridges the gap if the parent component's state update is debounced or deferred
  const [localValue, setLocalValue] = React.useState(props.value || props.defaultValue);

  // Sync with props when not dragging could be handled here or just trust props flows
  // Radix handles this well usually, but explicit sync is safe
  React.useEffect(() => {
    if (props.value) {
      setLocalValue(props.value);
    }
  }, [props.value]);

  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn("relative flex w-full touch-none select-none items-center", className)}
      onValueChange={(vals) => {
        setLocalValue(vals);
        onValueChange?.(vals);
      }}
      onValueCommit={onValueCommit}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800">
        <SliderPrimitive.Range className="absolute h-full bg-primary" />
      </SliderPrimitive.Track>
      {localValue?.map((_, i) => (
        <SliderPrimitive.Thumb
          key={i}
          className="block h-5 w-5 rounded-full border-2 border-primary bg-white ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 dark:border-slate-50 dark:bg-slate-950 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300 hover:scale-110 transition-transform cursor-grab active:cursor-grabbing"
        />
      ))}
    </SliderPrimitive.Root>
  )
})
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }